import React, { useEffect, useState } from 'react';
import {Box, Button, MenuItem, TextField, Typography, Paper } from '@mui/material';
import { handleWordpressPublishPostClick } from '../Handlers';
import { toast } from 'react-toastify';

const WordPressTab = ({
  selectedArticleId,
  selectedArticleTitle,
  selectedArticleSummary,
  selectedArticleLLMSummary
}) => {
  const [title, setTitle] = useState(selectedArticleTitle || '');
  const [summary, setSummary] = useState(selectedArticleSummary || '');
  const [llmSummary, setLLMSummary] = useState(selectedArticleLLMSummary || '');
  const [category, setCategory] = useState('');

  useEffect(() => {
    setTitle(selectedArticleTitle || '');
    setSummary(selectedArticleSummary || '');
    setLLMSummary(selectedArticleLLMSummary || '');
  }, [selectedArticleTitle, selectedArticleSummary, selectedArticleLLMSummary]);

  const handlePublish = async () => {
    try {
      await handleWordpressPublishPostClick(
        selectedArticleId, 
        title, 
        summary, 
        category,
        llmSummary
      );
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        label="Title"
        variant="outlined"
        margin="normal"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        helperText={`${title.length} / 200 characters`}
        inputProps={{ maxLength: 200 }}
      />
      <TextField
        fullWidth
        label="Summary"
        variant="outlined"
        margin="normal"
        multiline
        rows={4}
        value={summary}
        onChange={(e) => setSummary(e.target.value)}
        helperText={`${summary.length} / 600 characters`}
        inputProps={{ maxLength: 600 }}
      />
      <Box mt={2} mb={2}>
        <Box sx={{ mb: 1, display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="subtitle1" color="text.secondary">
            AI Generated Summary
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {llmSummary ? `${llmSummary.length} characters` : ''}
          </Typography>
        </Box>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            minHeight: '120px',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: llmSummary ? 'background.paper' : 'action.hover',
            overflowY: 'auto',
            userSelect: 'text',
            cursor: 'text',
            whiteSpace: 'pre-wrap',
            '&:hover': {
              borderColor: 'primary.main',
            }
          }}
        >
          {llmSummary ? (
            <Typography variant="body1">{llmSummary}</Typography>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              No AI-generated summary is available for this article.
            </Typography>
          )}
        </Paper>
      </Box>

      <TextField
        select
        fullWidth
        label="Category"
        variant="outlined"
        margin="normal"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      >
        <MenuItem value="politica">Política</MenuItem>
        <MenuItem value="ciencia">Ciencia</MenuItem>
        <MenuItem value="medioambiente">Medioambiente</MenuItem>
        <MenuItem value="heroes">Héroes</MenuItem>
        <MenuItem value="salud">Salud</MenuItem>
        <MenuItem value="social">Social</MenuItem>
        <MenuItem value="actualidad">Actualidad</MenuItem>
      </TextField>

      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button
          onClick={handlePublish}
          variant="contained"
          disabled={title.trim() === '' || summary.trim() === ''}
        >
          Publish to WordPress
        </Button>
      </Box>
    </Box>
  );
};

export default WordPressTab;